module.exports = __webpack_public_path__ + "img/body-2-lg.603dc61d.png";